import { useQueryClient } from 'react-query';

import { Config } from '@nw/shared/config';

const CommonDataStateURL = `${Config.COMMON_DATA_STATE_BASE_URL}`;

const fetchStatesData = (signal, countryId) => {
  return fetch(CommonDataStateURL, {
    signal,
    method: 'POST',
    body: JSON.stringify({
      data: JSON.stringify(
        JSON.stringify({
          country_id: countryId
        })
      ),
      clientKeyDetailsId: 1
    }),
    headers: { 'content-type': 'application/json' }
  }).then((res) => res.json());
};

const statesListQuery = (signal, countryId) => ({
  queryKey: ['satesList', countryId],
  queryFn: async () => fetchStatesData(signal, countryId)
});

export const useQueryClientStatesHook = async (signal, countryId) => {
  const queryClient = useQueryClient();
  const query = statesListQuery(signal, countryId);

  if (queryClient.getQueryData(query.queryKey)) {
    return queryClient.getQueryData(query.queryKey);
  }
  return await queryClient.fetchQuery(query.queryKey, query.queryFn, {
    cacheTime: Infinity
  });
};
